import { Copy, Pencil, ThumbsDown, ThumbsUp, Edit3 } from "lucide-react";
import "./AgentChatResponseToolbar.css";

import { copyMarkdownAsRichText } from "../uiHelpers";

import { AIResponseCanvasMessage } from "winslow-core";
import { FeedbackRating } from "./FeedbackRating";

type AgentCanvasResponseToolbarProps = {
  message: AIResponseCanvasMessage;
  children?: React.ReactNode;
  onEditInDocument?: (message: AIResponseCanvasMessage) => void;
};

export const AgentCanvasResponseToolbar = ({
  message,
  children,
  onEditInDocument,
}: AgentCanvasResponseToolbarProps) => {
  const handleCopy = async () => {
    await copyMarkdownAsRichText(message.message.content);
  };

  const handleEditInDocument = () => {
    if (onEditInDocument) {
      onEditInDocument(message);
    }
  };

  return (
    <div className="agent-chat-response-toolbar">
      <div className="agent-chat-response-toolbar-item" onClick={handleCopy}>
        <Copy size={16} />
      </div>
      {onEditInDocument && (
        <div
          className="agent-chat-response-toolbar-item"
          onClick={handleEditInDocument}
          title="Edit Document">
          <Edit3 size={16} />
        </div>
      )}
      {children}
      {/* Feedback rating for canvas messages */}
      <div className="" style={{ padding: "8px" }}>
        <FeedbackRating
          feedbackRating={message.feedbackRating}
          messageId={message.id}
        />
      </div>
    </div>
  );
};
